<template>
  <div class="flex flex-col max-w-[909px] w-full sm:mt-6">
    <div v-if="!isMobile" class="flex justify-between mr-[26px]">
      <div class="u-center">
        <OIcon icon="leaderboard" />
        <p class="text-[#161616] text-24 font-bold leading-20 ml-2.5">{{ current }} Sıralamalar</p>
      </div>
      <div class="u-center">
        <OButton pure @click="showHelpModal(currentGame)">
          <OIcon icon="info" />
        </OButton>
      </div>
    </div>
    <div
      v-if="isMobile"
      class="flex h-[69px] w-full bg-black px-6 py-3"
      :class="{ bilpopHeader: currentGame === 'bilpop', emojileHeader: currentGame === 'emojile' }"
    >
      <div v-if="isLoggedIn" class="flex w-full items-center justify-start">
        <div v-if="isPlayed" class="flex justify-between w-full text-white">
          <div class="u-center">
            <p
              class="border rounded-md u-center py-2 px-[7px] mr-2 w-[50px] h-[34px]"
              :class="{ bgBilpop: currentGame === 'bilpop', emojileHeader: currentGame === 'emojile' }"
            >
              {{ currentPlayerData.rank }}.
            </p>
            <OImage :key="user.username" loading="lazy" :src="userImg" class="mr-2 w-[45px] h-[45px] rounded-[100px] object-cover" />
            <p>{{ user.username }}</p>
          </div>
          <div class="u-center">
            <p class="text-white text-20 text-right sm:text-24 font-extrabold mr-1.5">{{ currentPlayerData.score }}</p>
            <OIcon icon="onedioPuan" />
          </div>
        </div>
        <div v-else class="flex flex-row items-center justify-start">
          <OImage :key="user.username" loading="lazy" :src="userImg" class="mr-2 w-[45px] h-[45px] rounded-[100px] object-cover" />
          <div class="flex text-md text-white">
            <p class="font-medium">
              Haydi {{ user.username }},
              <span class="font-bold">puanını ve sıralamanı belirle!</span>
            </p>
          </div>
        </div>
      </div>
      <div v-else class="flex flex-row u-center" @click="handleLoginModal">
        <div class="flex">
          <OImage :key="1" loading="lazy" src="/images/game/defaultPP.png" class="mr-2" />
        </div>
        <div class="flex flex-col text-md text-white">
          <p class="font-medium">Onedio üyesi ol,</p>
          <p class="font-bold">sen de sıralamalarda yerini al</p>
        </div>
      </div>
    </div>
    <div class="tab-pagination-siralama px-6 sm:px-0 flex flex-col sm:mr-[26px]">
      <div class="tabsAndPagination flex justify-between mt-4 mb-3 border-b border-divider-200 h-[46px] items-end pb-3">
        <div class="tabs flex justify-between relative text-md sm:text-xl leading-20 font-medium">
          <OButton
            pure
            class="px-2 py-1 mr-2"
            :class="{ 'border-b-2 border-[#1D2F75] font-bold ': currentTab === 'daily' }"
            @click="handleChangeTab('daily')"
          >
            Günlük
          </OButton>
          <OButton
            pure
            class="px-2 py-1 mr-2"
            :class="{ 'border-b-2 border-[#1D2F75] font-bold': currentTab === 'weekly' }"
            @click="handleChangeTab('weekly')"
          >
            Haftalık
          </OButton>
          <OButton
            pure
            class="px-2 py-1 mr-2"
            :class="{ 'border-b-2 border-[#1D2F75] font-bold': currentTab === 'monthly' }"
            @click="handleChangeTab('monthly')"
          >
            Aylık
          </OButton>
          <OButton
            pure
            class="px-2 py-1"
            :class="{ 'border-b-2 border-[#1D2F75] font-bold': currentTab === 'yearly' }"
            @click="handleChangeTab('yearly')"
          >
            Yıllık
          </OButton>
        </div>
        <div v-if="isMobile">
          <OButton pure @click="showHelpModal(currentGame)">
            <OIcon icon="info" />
          </OButton>
        </div>

        <div v-if="!isMobile" class="paginations u-center">
          <OButton v-if="currentPage >= 3" pure class="border rounded-lg mr-2 py-1 px-3 font-semibold text-lg" @click="today">
            Başa Dön
          </OButton>
          <OButton
            pure
            class="border cursor-pointer rounded-lg mr-2 u-center"
            :class="{ hidden: paginationInfo.page === 1 }"
            style="font-size: 27px; width: 36px; height: 36px; padding: 8px"
            @click="changePage(-1)"
          >
            <OIcon icon="chevron-left" />
          </OButton>
          <OButton pure class="border rounded-lg mr-2 py-1 px-3 font-semibold text-lg">{{ currentPage }}</OButton>
          <OButton
            pure
            class="border cursor-pointer rounded-lg u-center"
            :class="{ hidden: !paginationInfo.hasNextPage }"
            style="font-size: 27px; width: 36px; height: 36px; padding: 8px"
            @click="changePage(+1)"
          >
            <OIcon icon="chevron-right" />
          </OButton>
        </div>
      </div>
      <div class="siralamabilgsi flex justify-between items-center text-md font-normal text-[#7F8083] h-6 mb-4">
        <p># Sıralama</p>
        <div class="flex">
          <p class="mr-1">Kazanılan puan</p>
          <OIcon icon="onedioPuan" />
        </div>
      </div>
      <div ref="cards">
        <a
          v-for="(user, index) in players"
          :key="index"
          :href="`/profil/${user.player.username}`"
          class="flex w-full py-4 px-3 sm:pr-6 h-16 bg-white items-center justify-between mb-2 border-2 rounded-md border-black/[.08]"
          :class="{
            'border-[#9498A5]': me && me.me.rank === user.rank && isMobile,
            'border-4 border-[#9498A5]': me && me.me.rank === user.rank && !isMobile,
          }"
        >
          <div class="u-center">
            <OIcon v-if="user.rank === 1" icon="firstPlayer" class="w-8 h-8" />
            <OIcon v-if="user.rank === 2" icon="secondPlayer" class="w-8 h-8" />
            <OIcon v-if="user.rank === 3" icon="thirdPlayer" class="w-8 h-8" />
            <div v-if="user.rank > 3" class="font-bold leading-20 text-base w-8 h-8 py-1.5 u-center">{{ user.rank }}.</div>
            <OImage :src="getImageUrl(user.player.avatar)" class="w-8 h-8 rounded-full mx-2 object-cover" />
            <p class="text-[#161616] text-md sm:text-xl font-medium leading-20">{{ user.player.username }}</p>
          </div>
          <div class="text-20 text-right sm:text-24 font-extrabold text-[#161616]">
            {{ user.score }}
            <span v-if="!isMobile" class="text-20 font-normal">puan</span>
          </div>
        </a>
      </div>
      <div class="paginations flex items-center justify-end mt-4">
        <OButton v-if="currentPage >= 3" pure class="border rounded-lg mr-2 py-1 px-3 font-semibold text-lg" @click="today">
          Başa Dön
        </OButton>
        <OButton
          pure
          class="border cursor-pointer rounded-lg mr-2 u-center"
          :class="{ hidden: paginationInfo.page === 1 }"
          style="font-size: 27px; width: 36px; height: 36px; padding: 8px"
          @click="changePage(-1)"
        >
          <OIcon icon="chevron-left" />
        </OButton>
        <OButton pure class="border rounded-lg mr-2 py-1 px-3 font-semibold text-lg">{{ currentPage }}</OButton>

        <OButton
          pure
          class="border cursor-pointer rounded-lg u-center"
          :class="{ hidden: !paginationInfo.hasNextPage }"
          style="font-size: 27px; width: 36px; height: 36px; padding: 8px"
          @click="changePage(1)"
        >
          <OIcon icon="chevron-right" />
        </OButton>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, useContext, ssrRef, useAsync, computed } from '@nuxtjs/composition-api';
import { upperFirst } from 'lodash';
import { OIcon, OImage, OButton } from '~/modules/common/components/ui';
import { useDevice } from '~/composables/useDevice';
import { useAuth } from '~/modules/auth/state/useAuth';
import { useModal } from '~/composables/useModal';
import { getImageUrl } from '~/modules/common/utils/imageUtils';

export default defineComponent({
  props: {
    currentGame: {
      required: true,
      type: String,
    },
  },
  components: { OIcon, OImage, OButton },
  setup(props) {
    const { isMobile } = useDevice();
    const { user, isLoggedIn } = useAuth();
    const { openModal } = useModal();
    const players = ssrRef({});
    const paginationInfo = ssrRef({});
    const { $service } = useContext();
    const cards = ref(null);
    const userImg = getImageUrl(user.value?.avatar);
    const itemsPerPage = 20;
    const currentPage = ref(1);
    const currentTab = ref('daily');
    const current = upperFirst(props.currentGame);
    const me = ref();
    const currentPlayerData = ssrRef({});
    const isPlayed = computed(() => {
      return currentPlayerData.value.rank !== null;
    });
    const changePage = (x) => {
      cards.value.scroll({ top: 0, behavior: 'smooth' });
      window.scrollTo({ top: 0, behavior: 'smooth' });
      setTimeout(() => {
        currentPage.value += x;
        getLeaderboard();
      }, 500);
    };
    const handleChangeTab = (tab) => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      cards.value.scroll({ top: 0, behavior: 'smooth' });
      setTimeout(() => {
        currentPage.value = 1;
        currentTab.value = tab;
        getLeaderboard();
      }, 500);
    };
    const today = () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      cards.value.scroll({ top: 0, behavior: 'smooth' });
      setTimeout(() => {
        currentPage.value = 1;
        getLeaderboard();
      }, 500);
    };
    const showHelpModal = (game) => {
      if (game === 'emojile') {
        openModal(import('~/modules/emojile/components/ModalEmojileHelp' /* webpackChunkName: "ModalEmojileHelp" */));
      } else openModal(import('~/modules/bilpop/components/ModalBilpopHelp' /* webpackChunkName: "ModalBilpopHelp" */));
      // setTimeout(() => {
      //   const elem = document.getElementById('modal');
      //   if (elem) {
      //     elem.style.transform = 'translateY(0)';
      //   }
      // }, 150);
    };
    const getLeaderboard = async () => {
      try {
        const userParams = {
          boardType: props.currentGame,
          duration: currentTab.value,
          page: currentPage.value,
          limit: 20,
          playerId: user.value?._id,
        };
        const { data, pagination, extraData } = await $service.game.getLeaderboard(userParams);
        players.value = data;
        paginationInfo.value = pagination;
        me.value = extraData;
      } catch (err) {
        console.log(err);
      }
    };
    const getPlayerRank = async () => {
      try {
        const userParams = {
          boardType: props.currentGame,
          duration: 'yearly',
          playerId: user.value?._id,
        };
        const { data } = await $service.game.getPlayerRank(userParams);
        currentPlayerData.value = data;
      } catch (err) {
        console.log(err);
      }
    };
    const { openLoginModal } = useModal();
    const handleLoginModal = async () => {
      await openLoginModal();
    };
    useAsync(async () => {
      await getLeaderboard();
      if (isLoggedIn.value) {
        await getPlayerRank();
      }
    });

    return {
      handleChangeTab,
      currentTab,
      itemsPerPage,
      changePage,
      currentPage,
      isMobile,
      today,
      user,
      isLoggedIn,
      userImg,
      cards,
      showHelpModal,
      current,
      players,
      paginationInfo,
      me,
      currentPlayerData,
      isPlayed,
      getImageUrl,
      handleLoginModal,
    };
  },
});
</script>
<style scoped lang="scss">
.bilpopHeader {
  background: linear-gradient(166deg, #400677 -6.27%, #6e2fbf 106.87%);
}
.emojileHeader {
  background: linear-gradient(166deg, #00084d -6.27%, #2c4389 106.87%);
}
.bgBilpop {
  background: linear-gradient(166deg, #7129bf -6.27%, #2e045c 106.87%);
}
</style>
